import { Component } from '@angular/core';
import { BaseListComponent } from "../base/base-list.component";

@Component({
    selector: 'gerenciamento-capacitadora',
    templateUrl: './gerenciamento-capacitadora.component.html',
})
export class GerenciamentoCapacitadoraComponent extends BaseListComponent {
    controllerName = 'capacitadora';
    filtro = this.formBuilder.group({
        query: [null]
    });

    init() {
        this.listagem.pDatatableComponent.sortOrder = 2;
        this.carregarEstado();
    }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-capacitadora/gerenciamento-capacitadora.component.ts